import React, { useEffect, useRef } from 'react';
import { useAuth } from './context';
import { Navigate, useLocation } from 'react-router-dom';
import { useToast } from '../../hooks/useToast';
import { loginPathWithNext } from './nextPath';

const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const { showToast } = useToast();
  const location = useLocation();
  const lastNotifiedPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (!loading && !user && location.pathname !== '/') {
      if (lastNotifiedPathRef.current !== location.pathname) {
        showToast({
          title: 'Authentication Required',
          message: 'Please log in to access this page',
          type: 'info',
          duration: 5000,
        });
        lastNotifiedPathRef.current = location.pathname;
      }
    }
  }, [loading, user, location.pathname, showToast]);

  if (loading) return null;
  
  if (!user) {
    // Straight to /login (not "/" → RootRedirect) so the destination survives
    // as ?next=. See features/auth/nextPath.ts for the same-origin allowlist.
    return <Navigate to={loginPathWithNext(location)} replace />;
  }
  
  return <>{children}</>;
};

export default RequireAuth; 